import { jsx as _jsx } from "react/jsx-runtime";
import { LegalText } from "@jti/ui";
import styles from "./ConsentsLegalIntroduction.module.scss";
export const ConsentsLegalIntroduction = ({ legalText }) => (_jsx(LegalText, { legalText: legalText, className: styles.legalText }));
